<template>
  <div>
    <p v-if="ShowMsg">{{ ShowMsg }}</p>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import storage from "../../common/utils/storage";

export default {
  data() {
    return {
      userInfo: null,
      ShowMsg: "",
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        console.log('用户信息',res.Data);
        console.log('页面参数',this.$route.query);
        this.userInfo = res.Data;
        if(this.userInfo.BaseInfo.Status>=30){
          this.ShowMsg='恭喜您，您已经注册成功。请点击左上角“X”关闭此提醒页面。然后在您的电脑或手机端继续操作投稿流程。';
        }
      });
    },
  },
};
</script>
